/**
 * Ex data
 * TODO: Load from database
 */

import historical from "../../data/historical";
import articles from "../../data/articles";
import processDesign from "../../data/processDesign";

historical.data.map(obj => {
  obj.article = articles.data.find(art => art.id === obj.idArticle);
  obj.design = processDesign.data.find(dsg => dsg.id === obj.idDesign);
  return obj;
});

const INITIAL_STATE = {
  data: historical.data,
  pieceSelected: null,
  temporalLine: historical.temporal
};

const loadHistoricalReducer = (state = INITIAL_STATE, action) => {
  
  switch (action.type) {
    case "SET_PIECE":
      return { ...state, pieceSelected: action.piece };
    default:
      return state;
  }
};

export default loadHistoricalReducer;
